import { Dispatch, SetStateAction } from 'react';
import {
  BlogArticleDocumentDataContentItem,
  Simplify,
} from '../../../../../../../../../prismicio-types';
import {
  ContentHeading,
  ContentImage,
  ContentList,
  ContentMessage,
  Paragraph,
} from '.';

interface ContentProps {
  content: Simplify<BlogArticleDocumentDataContentItem>;
  setOffsetElement: Dispatch<SetStateAction<string>>;
}

export const Content = ({ content, setOffsetElement }: ContentProps) => {
  switch (content.type) {
    case 'Bulleted list':
      return <ContentList type="bulleted" content={content.text} />;
    case 'Numbered list':
      return <ContentList type="numbered" content={content.text} />;
    case 'Heading':
      return (
        <ContentHeading
          content={content.heading}
          setOffsetElement={setOffsetElement}
        />
      );
    case 'Image':
      return (
        <ContentImage image={content.image} caption={content.image_caption} />
      );
    case 'Messsage':
      return (
        <ContentMessage
          content={content.text}
          author={content.message_author}
        />
      );
    case 'Text':
      return <Paragraph content={content.text} />;
    default:
      return null;
  }
};
